












































































import { Component, Prop, Vue } from "vue-property-decorator";
import { TweenMax, Power4 } from "gsap";

@Component
export default class Contact extends Vue {
  msn = "Copy to clipboard";
  that = this;

  mounted() {
    TweenMax.from(document.getElementById("project__curtain"), 1, {
      x: "100vw",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
    });
    TweenMax.from(document.getElementById("project__container"), 1, {
      x: "100vw",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
      delay: 0.4,
    });
  }

  leave(el: any, done: any) {
    TweenMax.to(document.getElementById("project__container"), 0.5, {
      y: "100vh",
      ease: Power4.easeIn,
      // onComplete: done,
    });
    TweenMax.to(document.getElementById("project__curtain"), 0.3, {
      y: "100vh",
      transformOrigin: "left 50%",
      ease: Power4.easeIn,
      delay: 0.3,
      onComplete: done,
    });
  }

  clipboard() {
    const el = document.createElement("textarea");
    el.value = "contact@lightskillsdojo.art";
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);

    const title = document.getElementById("email");
    this.msn = "Copied!";
  }

  changeMsn() {
    this.msn = "Copy to clipboard";
  }
}
